/**
 * Created by handd on 2021/10/27.
 * 消息类别管理
 */
import axios from "axios";
import {message} from "antd";

// const
const MESSAGE_CATEGORY_TOGGLE_LOADING = "messageCategory/MESSAGE_CATEGORY_TOGGLE_LOADING";//加载标志
const MESSAGE_CATEGORY_TOGGLE_BUTTON_LOADING = "messageCategory/MESSAGE_CATEGORY_TOGGLE_BUTTON_LOADING";//提交加载标志
const MESSAGE_CATEGORY_UPDATE_DATA = "messageCategory/MESSAGE_CATEGORY_UPDATE_DATA";
const MESSAGE_CATEGORY_STORE_MESSAGE_CATEGORIES = "messageCategory/MESSAGE_CATEGORY_STORE_MESSAGE_CATEGORIES";
const MESSAGE_CATEGORY_STORE_RELOAD_MESSAGE_CATEGORIES = "messageCategory/MESSAGE_CATEGORY_STORE_RELOAD_MESSAGE_CATEGORIES";
const MESSAGE_CATEGORY_ADD_MESSAGE_CATEGORY = "messageCategory/MESSAGE_CATEGORY_ADD_MESSAGE_CATEGORY";
const MESSAGE_CATEGORY_EDIT_MESSAGE_CATEGORY = "messageCategory/MESSAGE_CATEGORY_EDIT_MESSAGE_CATEGORY";
const MESSAGE_CATEGORY_VIEW_MESSAGE_CATEGORY = "messageCategory/MESSAGE_CATEGORY_VIEW_MESSAGE_CATEGORY";

// reducer
export const messageCategory = (state = {
  loading: false,
  buttonLoading: false,
  addVisible: false,
  editVisible: false,
  viewVisible: false,

  messageCategories: [],
  messageCategory: {},

}, action) => {
  switch (action.type) {
    case MESSAGE_CATEGORY_TOGGLE_LOADING:
      return {
        ...state,
        loading: action.data
      };
    case MESSAGE_CATEGORY_TOGGLE_BUTTON_LOADING:
      return {
        ...state,
        buttonLoading: action.data
      };
    case MESSAGE_CATEGORY_UPDATE_DATA:
      return {
        ...state,
        [action.data.name]: action.data.value
      };
    case MESSAGE_CATEGORY_STORE_MESSAGE_CATEGORIES:
      return {
        ...state,
        loading: false,
        buttonLoading: false,
        addVisible: false,
        editVisible: false,
        viewVisible: false,
        messageCategories: action.data,
        messageCategory: {},
      };
    case MESSAGE_CATEGORY_STORE_RELOAD_MESSAGE_CATEGORIES:
      return {
        ...state,
        loading: false,
        buttonLoading: false,
        addVisible: false,
        editVisible: false,
        viewVisible: false,
        messageCategories: action.data,
        messageCategory: {},
      };
    case MESSAGE_CATEGORY_ADD_MESSAGE_CATEGORY:
      return {
        ...state,
        messageCategory: {},
        addVisible: true
      };
    case MESSAGE_CATEGORY_EDIT_MESSAGE_CATEGORY:
      return {
        ...state,
        messageCategory: action.data,
        editVisible: true
      };
    case MESSAGE_CATEGORY_VIEW_MESSAGE_CATEGORY:
      return {
        ...state,
        messageCategory: action.data,
        viewVisible: true
      };
    default:
      return state
  }
};

/**
 * update data based
 */
export const updateMessageCategoryData = (data) => {
  return {
    type: MESSAGE_CATEGORY_UPDATE_DATA,
    data: data
  }
};

/**
 * toggle loading
 */
export const toggleLoading = (show) => {
  return {
    type: MESSAGE_CATEGORY_TOGGLE_LOADING,
    data: show
  }
};

/**
 * toggle button loading
 */
export const toggleButtonLoading = (show) => {
  return {
    type: MESSAGE_CATEGORY_TOGGLE_BUTTON_LOADING,
    data: show
  }
};

/**
 * query all message categories
 */
export const queryMessageCategories = () => (dispatch) => {
  axios.get(`/api-message/messageCategories`, {contentType: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storeMessageCategories(response.data));
          // message.success("查询成功", 1);
        } else {
          message.warning("未获取到消息类别", 3);
        }
      }
    }
  ).catch(err => {
    message.error("获取消息类别错误：" + err.data, 3);
  });
};

/**
 * store all message categories
 */
export const storeMessageCategories = (messageCategories) => {
  return {
    type: MESSAGE_CATEGORY_STORE_MESSAGE_CATEGORIES,
    data: messageCategories
  }
};

/**
 * reload message categories
 */
export const reloadMessageCategories = () => (dispatch) => {
  axios.get(`/api-message/messageCategories`, {contentType: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if (response.data) {
          dispatch(storeReloadMessageCategories(response.data));
          message.success("刷新成功", 1);
        } else {
          message.warning("未查询到消息类别", 3);
        }
      }
    }
  ).catch(err => {
    message.error("刷新错误：" + err.data, 3);
  });
};


/**
 * store reload message categories
 */
export const storeReloadMessageCategories = (messageCategories) => {
  return {
    type: MESSAGE_CATEGORY_STORE_RELOAD_MESSAGE_CATEGORIES,
    data: messageCategories
  }
};

/**
 * add message category
 */
export const addMessageCategory = () => {
  return {
    type: MESSAGE_CATEGORY_ADD_MESSAGE_CATEGORY,
  }
};

/**
 * edit message category
 */
export const editMessageCategory = (messageCategory) => {
  return {
    type: MESSAGE_CATEGORY_EDIT_MESSAGE_CATEGORY,
    data: messageCategory
  }
};

/**
 * view message category
 */
export const viewMessageCategory = (messageCategory) => {
  return {
    type: MESSAGE_CATEGORY_VIEW_MESSAGE_CATEGORY,
    data: messageCategory
  }
};

/**
 * submit message category
 */
export const submitMessageCategory = (data) => (dispatch) => {
  message.loading({content: `保存中……`, key: "submit"});
  axios({
    method: "POST",
    url: `/api-message/messageCategory`,
    contentType: "application/json",
    withCredentials: true,
    data: data,
  }).then(
    response => {
      if (response.status === 200) {
        message.success({content: `保存成功`, key: "submit", duration: 1});
        data.reload();
      } else {
        message.error({content: `保存失败！`, key: "submit", duration: 3});
        dispatch(toggleButtonLoading(false));
      }
    }
  ).catch(err => {
    message.error({content: "保存错误：" + err.data, key: "submit", duration: 3});
    dispatch(toggleButtonLoading(false));
  });
};


/**
 * delete message category
 */
export const deleteMessageCategory = (data) => (dispatch) => {
  message.loading({content: "删除中……", key: "delete"});
  axios({
    method: "DELETE",
    url: `/api-message/messageCategory`,
    contentType: "application/json",
    withCredentials: true,
    data: data.ids,
  }).then(
    response => {
      if (response.status === 200) {
        message.success({content: "删除成功", key: "delete", duration: 1});
        data.reload();
      } else {
        message.error({content: "删除失败", key: "delete", duration: 3});
      }
    }
  ).catch(err => {
    message.error({content: "删除错误："+ err.data, key: "delete", duration: 3});
  });
};
